export const createTypes = (type) => {
  return {
    success: `${type}_SUCCESS`,
    loading: `${type}_LOADING`,
    failure: `${type}_FAILURE`,
  }
}
